export default "__VITE_ASSET__BHCjx6X4__"